import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { BatchReportService } from 'src/app/services/batch-report-service';
import { ProductivityService } from 'src/app/services/productivity-service';
import * as moment from 'moment';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
@Component({
  selector: 'app-batch-report-output',
  templateUrl: './batch-report-output.component.html',
  styleUrls: ['./batch-report-output.component.scss']
})
export class BatchReportOutputComponent implements OnInit {
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort  = new QueryList<MatSort>();
  @ViewChild('batchViewModal') private batchViewModal!: TemplateRef<any>;

  shiftList=[{
    value:'all',
    name:'ALL',
   
  },{
    value:'day',
    name:'Day',
  },{
    value:'night',
    name:'Night',
  }]
  
  public rowData!: any[];
  public columnDefs!: any[];
  public gridApi: any;
  public gridColumnApi: any;
  frameworkComponents: any;
  public defaultExportParams!:any;
  public defaultColDef!: any;
  public detailCellRendererParams!: any;
  public excelStyles!:any;
  Exdpandhide = true;
  Collapsehide = false;
  isCardExpanded = false;
  Isexpandcontentshow = true;
  Isexpandcontenthide = true;
  Isexpandcontentbuttonshow = false;
  gridOptions: any = {
    defaultColDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      flex: 1,
      filter : true,
      sortable: true,
      resizable: true,
      wrapText: true,     // <-- HERE
      autoHeight: true,   // <-- & HERE
      minWidth: 225,
    },
  };
  lang: any;
  constructor(
    private formBuilder: FormBuilder,
    private toaster: ToastrService,
    private userService: UserManagementService,
    private dialog: MatDialog,
    private productivityservice: ProductivityService,
    private enterpriseGroupService: EnterPriseGroupService,
    private batchReportService :BatchReportService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private translater: TranslaterService,
    private translate: TranslateService
  ) { this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();})
    // this.frameworkComponents = {
    //   buttonViewRenderer : ButtonViewRendererComponent,
    // }
    this.defaultExportParams = {
      getCustomContentBelowRow: function (params:any) {
        return [
          [
            cell('',''),
            cell('Name', 'header'),
            cell('Value', 'header')
          ],
        ].concat(
          params.node.data.batchItemBomList.map(function (record:any) {
            return [
              cell('',''),
              cell(record.Name, 'body'),
              cell(record.BatchCheckListValue, 'body')
            ];
          }),
          [[]]
        );
      },
      columnWidth: 120,
    };
    this.columnDefs = [
{headerName : 'Sr.No', field:'SNo', valueGetter: "node.rowIndex + 1",cellRenderer: 'agGroupCellRenderer', headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Pallet/Batch No', field:'BatchNo', headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'PO', field:'PO', headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Item Code', field:'ItemCode', headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Item Desc', field:'ItemDesc', headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Actual Qty', field:'Result', headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Production Date', field:'RollStarttime',valueFormatter: function (params: any) { return moment(params.value).format('MM/DD/YYYY HH:mm') }},
{headerName : 'Remarks', field:'Remarks', headerValueGetter: this.localizeHeader.bind(this)},
// {headerName : 'Machine', field:'Machine'},
// {headerName : 'Is Rework', field:'IsRework', cellRenderer: (params:any) => params.value === true ? "Yes" : "No",maxWidth : 120},
// {headerName : 'Operation', field:'Operation'},
{headerName : 'Created On', field:'CreatedOn',valueFormatter: function (params: any) { return moment(params.value).format('MM/DD/YYYY HH:mm') }, headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Created By', field:'CreatedBy', headerValueGetter: this.localizeHeader.bind(this)},
// {headerName : 'Action',  cellRenderer: 'buttonViewRenderer', cellRendererParams: { onClick: this.onClickView.bind(this), label: 'View' }, maxWidth: 85, suppressMenu: true}
    ];
    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          { headerName: 'Name', field:'Name', filter: true, resizable: true, wrapText: true, headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'Value', field:'BatchCheckListValue',  filter: true, resizable: true, wrapText: true, headerValueGetter: this.localizeHeader.bind(this) },
        ],
       defaultColDef: { flex: 1 },
      },
      getDetailRowData: function (params: any) {
      params.successCallback(params.data.batchItemBomList);
      },
    };
    this.excelStyles = [
      {
        id: 'header',
        interior: {
          color: '#a47ed9',
          pattern: 'Solid',
        },
      },
      {
        id: 'body',
        interior: {
          color: '#d1c1e8',
          pattern: 'Solid',
        },
      },
    ];
  }

  // form unitDetailForm fields controls
  public disabled = true;
  public showSpinners = true;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  unitList!: any[];
  itemList!: any[];
  filteredItemCodes!:any[];
  processOrderList!: any[];
  filteredPOs!:any[];
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!:any;
  batchReportViewDatasource!:  MatTableDataSource<any>;
  MachineId!: any;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  permisson!: any;
  IsAccess!: any;
  IsWrite!: any;
  breadcrumList!: any;
  isPopupMachine = false;
  prodDesc!: any;
  NB!:number;
  NPO! : number;
  TAQ!:number;
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';

  public formGroup = new FormGroup({
    date: new FormControl(null, [Validators.required]),
  });

  productionColumns: any[] = ['checklist', 'values'];
  batchForm!: FormGroup;
  UnitNode: any;
  Group: string | undefined;
  length : boolean = false;
  inputReadonly = true;
  UnitName: string | undefined;
  isUnitName = false;
  ngOnInit(): void {
    this.GetBreadcrumList();
    this.GetMenuAccess();
    // // this.spinner.show(); 
    this.batchForm = this.formBuilder.group({
      UserGroup1: [],
      UserPlant1: [],
      startDate : [],
      endDate: [],
      line : [],
      unit:[],
      ItemCode: [],
      po: [],
      batchType :[],
      shift :[],
      queryCriteria :[],
    });

    this.datasource();
    this.batchForm.controls.line.valueChanges.subscribe((selectedValue: any) => {
      this.getUnit(selectedValue);
    });

    this.batchForm.controls.UserPlant1.valueChanges.subscribe((value: any) => {
      this.getLine(value);
    });

    this.batchForm.get('queryCriteria')?.patchValue('today');
    this.batchForm.get('shift')?.patchValue('all');
    this.batchForm.get('batchType')?.patchValue('0'); 
    const event = {
      value : 'today'
    } 
    this.criteriaChange(event);
  };

 
  // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit(): any {
    // this.orderProcessingVariableGroupData.paginator = this.paginator;
    // this.orderProcessingVariableGroupData.sort = this.sort;
  }

  onItemCodeChange(event : any):void { 
    this.getProcessOrder(event.value);
  }

  onPOChange(event : any):void{
    this.batchForm.get('po')?.setValue(event.value);
  }


  datasource(): void {
    const key = {
      Id: 0
    };
    const id = {
      value: 0
    };
    // tslint:disable-next-line: 
    this.productivityservice.getGroupData(key).subscribe((data: any) => {
      this.GroupList = data.lstEG;
      id.value = data.lstEG[0].EG_Id;
      this.length = this.GroupList.length >1 ? true : false;
      this.batchForm.get('UserGroup1')?.patchValue(data.lstEG[0].EG_Id);
      this.batchForm.get('UserPlant1')?.patchValue(data.lstEG[0].EG_Id);
      this.getPlants(id);
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  }

  onSubmit(): void {
   this.spinner.show();
   this.getBatchReport();
  }


  criteriaChange(event:any):void {
    let startDate = new Date();
    let endDate = new Date();
    if(event.value === 'lastshift'){
      startDate.setDate(startDate.getDate() -1);
      startDate.setHours(19);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate.setHours(7);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      this.batchForm.get('startDate')?.patchValue(startDate);
      this.batchForm.get('endDate')?.patchValue(endDate);
      this.disabled = true;
    }else if(event.value === 'yesterday'){
      startDate.setDate(startDate.getDate() -1);
      startDate.setHours(7);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate.setHours(7);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      this.batchForm.get('startDate')?.patchValue(startDate);
      this.batchForm.get('endDate')?.patchValue(endDate);
      this.disabled = true;
    }else if(event.value === 'today'){
      startDate.setHours(7);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate.setHours(19);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      this.batchForm.get('startDate')?.patchValue(startDate);
      this.batchForm.get('endDate')?.patchValue(endDate);
      this.disabled = true;
    }else{
      this.disabled = false;
      this.batchForm.get('startDate')?.patchValue(startDate);
      this.batchForm.get('endDate')?.patchValue(endDate);
    }
  }

  getPlants(event: any): void {
    const key = {
      EG_ID: event.value,
      userId: 206
    };

    this.productivityservice.getPlantsData(key).subscribe((data: any) => {
      this.PlantList1 = data.lstPlant;
      const id = data.lstPlant[0].PT_Id;
      this.batchForm.get('UserPlant1')?.patchValue(id);
      this.getLine(id);
      this.getItemCode();
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  getLine(id: any) {
    const key = {
      PT_ID: id,
      userId: 206
    };

    this.productivityservice.getLineData(key).subscribe((data: any) => {
      this.lineList = data.lstLine;
      const lineDefault = this.lineList[0];
      this.batchForm.controls.line.patchValue(lineDefault.PL_Id);
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  getUnit(id: number) {
    const key = {
      PL_ID: id,
      userId: 206
    };

    this.productivityservice.getUnitData(key).subscribe((data: any) => {
      this.unitList = data.lstUnit;
      const unitDefault = this.unitList[0];
      if(unitDefault){
        this.batchForm.controls.unit.patchValue(unitDefault.PU_Id);
      }else{
        this.batchForm.controls.unit.patchValue("0");
      }
     
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });

  }

  getItemCode(): void {
    const key = {
      EGId: this.batchForm.value.UserGroup1,
      PTId: this.batchForm.value.UserPlant1
    };
    this.batchReportService.getItemCode(key).subscribe((data: any) => {
      this.itemList = data.ItemInfoList;
      this.filteredItemCodes = this.itemList.slice();
      this.batchForm.get('ItemCode')?.patchValue(this.itemList[0].ItemCode);
      const id = this.itemList[0].ItemCode;
      this.getProcessOrder(id);
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  getProcessOrder(itemCode:any): void {
    const key = {
      ItemCode: itemCode,
      PTId :this.batchForm.value.UserPlant1
    };
    this.batchReportService.getProcessOrder(key).subscribe((data: any) => {
      this.processOrderList = data.masterList;
      this.filteredPOs = this.processOrderList.slice();
      this.processOrderList.length > 0 ? this.batchForm.get('po')?.setValue(this.processOrderList[0].TypeName):this.batchForm.get('po')?.setValue("0");
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  getBatchReport():void {
    const key = {
      PTID: this.batchForm.value.UserPlant1,
      PLId: this.batchForm.value.line,
      PUId: this.batchForm.value.unit,
      ItemCode: this.batchForm.value.ItemCode,
      PO: this.batchForm.value.po,
      BatchType: parseInt(this.batchForm.value.batchType),
      FromDate: this.batchForm.value.startDate,
      ToDate: this.batchForm.value.endDate,
      shift : this.batchForm.value.shift
    };
    this.batchReportService.getBatchOutReport(key).subscribe((data: any) => {
      this.rowData = data.BatchItemBOMList;
      this.NB = data.NB.toFixed(2);
      this.NPO = data.NPO.toFixed(2);
      this.TAQ = data.TAQ.toFixed(2);
      this.spinner.hide();
    }, (error: any) => {
      this.toaster.error('Error', error.message);
      this.spinner.hide();
    });
  }

  onClickView(data:any):void{
    this.openPopupViewBatchHistory(data.data);
  }

  openPopupViewBatchHistory(element: any): void {
    this.dialog.open(this.batchViewModal, {
      width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
    })
     this.getBatchItemBOMInfo(element);
  }

  getBatchItemBOMInfo(element : any):void{
    const key = {
      JobBatchId : element.JobBatchId,
      PUId: this.batchForm.value.unit
    };
    this.batchReportService.getJobBatchInfoDetails(key).subscribe((data: any) => {
      this.batchReportViewDatasource = data.batchCheckList;
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value:string){
    let val;
    if(this.langObj && this.langObj[value]){
      val = this.langObj[value];
    }
    return val?val:value;
 }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if(this.langObj){
        this.gridApi.refreshHeader();
      }
    });
  }
   //menu and breadcrumb
   GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.userService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length -1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater,this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe((data: any) => {
      this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
    // return false;
  }
  //===================================================================== AG Grid (TODO : AbdurRazique) =================================================================//
  expand() {
    this.isCardExpanded = !this.isCardExpanded;
    this.Exdpandhide = false;
    this.Collapsehide = true;
    this.Isexpandcontentshow = true;
    this.Isexpandcontenthide = false;
    this.Isexpandcontentbuttonshow = true;
  }

  close() {
    this.isCardExpanded = !this.isCardExpanded;
    this.Exdpandhide = true;
    this.Collapsehide = false;
    this.Isexpandcontentshow = true;
    this.Isexpandcontenthide = true;
    this.Isexpandcontentbuttonshow = false;
  }
  
  onFirstDataRendered(params: any) {
    setTimeout(function () {
      params.api.getDisplayedRowAtIndex(1).setExpanded(true);
    }, 0);
  }
  excelExport() {
    var params = {
      fileName: 'BatchOutput',
    } 
    this.gridApi.exportDataAsExcel(params);
  }
  csvExport(){
    var params = {
      fileName: 'BatchOutput',
    } 
    this.gridApi.exportDataAsCsv(params);
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit(); 
  }

}
function cell(text:any, styleId:any) {
  return {
    styleId: styleId,
    data: {
      type: /^\d+$/.test(text) ? 'Number' : 'String',
      value: String(text),
    },
  };
}